// extracted by mini-css-extract-plugin
export default {"wrapper":"case-study_wrapper__KANNr","container":"case-study_container__Ap9qK","header":"case-study_header__NS+Oy","desc":"case-study_desc__bDipa"};